var exports = {
  "kL": "xaee3c4fa--10a2d6--container",
  "DD": "xaee3c4fa--10a2d6--title",
  "qK": "xaee3c4fa--10a2d6--buttons-wrapper",
  "x6": "xaee3c4fa--10a2d6--button",
  "A1": "xaee3c4fa--10a2d6--_active",
};

module.exports = exports;
